/**
 * The site shell around the route modules (web plan W4.4): what `<App/>` puts
 * around every page it still renders from the catch-all — the URL prefix's
 * language, scroll reset and page views per navigation, and AppShell's
 * header, `<main>` (this layout's `<Outlet/>`) and footer; plus the bar that
 * shows while an in-app navigation loads (a data router's own state).
 *
 * A pathless layout (src/routes.ts): it adds no URL segment of its own.
 */
import AppShell from '@/components/layout/AppShell';
import { NavigationProgress } from '@/components/layout/NavigationProgress';
import { PageViews, RememberLocale, ScrollToTop } from '@/components/layout/RouteEffects';
import { RouteLanguage } from '@/i18n/LocaleLanguage';

export default function ShellLayout() {
  return (
    <RouteLanguage>
      <ScrollToTop />
      <PageViews />
      <RememberLocale />
      <NavigationProgress />
      <AppShell />
    </RouteLanguage>
  );
}
